import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';

const Categories = () => {
  const { categories } = useSite();
  if (!categories || categories.length === 0) return null;
  return (
    <section className="bg-black py-20">
      <div className="max-w-[1480px] mx-auto px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-[#d4af37] tracking-[0.4em] text-xs uppercase mb-3">All Categories</p>
            <h2 className="serif-italic gold-gradient-text text-5xl md:text-6xl">Shop by Range</h2>
          </div>
          <Link to="/shop" className="text-[#d4af37] hover:underline serif-italic text-lg hidden md:inline">View All Products</Link>
        </div>

        <div className={`grid gap-6 ${categories.length >= 3 ? 'md:grid-cols-3' : categories.length === 2 ? 'md:grid-cols-2' : 'md:grid-cols-1'}`}>
          {categories.map((c) => (
            <Link key={c.id} to={`/shop?cat=${c.slug}`} className="group relative h-[360px] overflow-hidden rounded-md border border-zinc-900 hover:border-[#d4af37] transition-colors">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-10 text-center px-4">
                <p className="text-[#d4af37] text-xs tracking-[0.3em] uppercase mb-2">Range</p>
                <h3 className="serif-italic text-4xl md:text-5xl gold-gradient-text">{c.name}</h3>
                {c.description && <p className="text-zinc-400 text-sm mt-2 max-w-xs">{c.description.slice(0, 80)}{c.description.length > 80 ? '…' : ''}</p>}
                <span className="mt-4 inline-block border-b border-[#d4af37] text-[#d4af37] text-sm pb-1">Explore</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
